<template>
  <IndexSubirFotos v-if="oferta || packFoto" :oferta="oferta" :packFoto="packFoto" />
</template>

<script>
import IndexSubirFotos from '@/components/SubirFotos/Index.vue'

export default {
  name: 'SubirFotos',
  components: {
    IndexSubirFotos
  },
  data () {
    return {
      oferta: null,
      packFoto: null
    }
  },
  created () {
    // Depende el tipo de ruta que se llamo (por pack foto o por oferta), se busca el recurso que corresponde
    switch (this.$route.name) {
      case 'subir-fotos-pack':
        this.$apiService.getPackFoto(this.$route.params.id)
          .then(response => {
            const packFoto = response.data
            // Solo avanza si el pack foto no es dinamico, esto seria un error y vuelve al inicio
            if (packFoto.oferta.tipoPackFoto !== this.$constantes.ofertas.tiposPackFotos.DINAMICO && packFoto.habilitadoCompleto) {
              this.packFoto = packFoto
            } else {
              this.$router.push({ name: 'inicio' })
            }
          })
          .catch(error => {
            this.mensajeErrorAxios(error, this)
          })
        break
      case 'subir-fotos-oferta':
        this.$apiService.getOferta(this.$route.params.id)
          .then(response => {
            const oferta = response.data
            // Solo avanza si la oferta es dinamica, esto seria un error y vuelve al inicio
            if (oferta.tipoPackFoto === this.$constantes.ofertas.tiposPackFotos.DINAMICO && oferta.habilitadoCompleto) {
              this.oferta = oferta
            } else {
              this.$router.push({ name: 'inicio' })
            }
          })
          .catch(error => {
            this.mensajeErrorAxios(error, this)
          })
        break
    }
  }
}
</script>
